var path = '/templates/projects.analytics/views/directives/pie_chart.html';
var html = "<div class=userstats><h4>{{project.title}} / {{ 'projectsAnalytics.views.directives.pieChart.yuuzaajouhou' | translate }}</h4><div class=row><div class=col-md-6><highchart config=deviceConfig></highchart></div><div class=col-md-6><highchart config=newSessionConfig></highchart></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.analytics/views/directives/pie_chart.html
// module id = 1335
// module chunks = 0